var React = require('react');

function DiamondPink (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 27.9097L7.21917 39.91L21.8582 0L0 27.9097Z","fill":"#FFCFFA","key":0}),React.createElement("path",{"d":"M7.21875 39.91H36.4968L21.8578 0L7.21875 39.91Z","fill":"#F481AB","key":1}),React.createElement("path",{"d":"M36.4955 39.91L43.7098 27.9097L21.8564 0L36.4955 39.91Z","fill":"#DA5D8A","key":2})]);
}

DiamondPink.defaultProps = {"width":"44","height":"40","viewBox":"0 0 44 40","fill":"none"};

module.exports = DiamondPink;

DiamondPink.default = DiamondPink;
